import { IconButton, makeStyles, Tooltip } from '@material-ui/core';
import clsx from 'clsx';
import React from 'react';
import { FaInfo, FaSyncAlt } from 'react-icons/fa';

const nossoNumeroStyles = makeStyles({
  container: {
    display: 'flex',
  },
  progress: {
    '&>progress[value]': {
      /* Reset the default appearance */
      '-webkit-appearance': 'none',
      '-moz-appearance': 'none',
      appearance: 'none',

      /* Get rid of default border in Firefox. */
      border: 'none',

      /* Dimensions */
      height: 5,
      width: '100%',
    },
    /* background: */
    '&>progress::-webkit-progress-bar': {
      backgroundColor: '#BDCEE1',
      width: '100%',
    },

    /* value: */
    '&>progress::-webkit-progress-value': {
      backgroundColor: '#255C9D !important',
    },
    '&>progress::-moz-progress-bar': {
      backgroundColor: '#255C9D !important',
    },
    '&>progress': {
      color: '#255C9D',
    },
    flex: 1,
  },
  error: {
    /* value: */
    '&>progress::-webkit-progress-value': {
      backgroundColor: '#B53839 !important',
    },
    '&>progress::-moz-progress-bar': {
      backgroundColor: '#B53839 !important',
    },
    '&>progress': {
      color: '#B53839',
    },
  },
  button: {
    width: 35,
    marginLeft: 4,
  },
});

/*
RNE-307 - Comportamento da barra embaixo das cobranças
O sistema deve exibir a barra demonstrando a situação de envio da cobrança para registro no banco.

Quando a cobrança estiver pendente de envio, seja porque ainda não foi enviada ou porque sofreu alteração (alteração de algum dado, baixa manual ou exclusão), o sistema deve acender a primeira parte da barra.

Quando a cobrança já estiver sido enviada para registro (Partner Bank) ou quando a remessa tiver sido gerada (Banco tradicional e Pix), o sistema deve acender a segunda parte da barra.

Caso a cobrança seja retornada com algum erro, o sistema deve acender a terceira parte da barra e marcar as 3 barras acesas em vermelho.
Banco tradicional: CNAB 240: Códigos 03, 26, 30 e 37; CNAB 400: Códigos 03, 24, 27, 30 e 32.
Pix: Código 3

Caso a cobrança seja retornada com sucesso, o sistema deve acender a terceira parte da barra normalmente.
Banco tradicional: Todos os códigos do CNAB exceto os descritos acima.
Pix: Código 2

Quando o sistema identificar que a cobrança foi paga pelo arquivo retorno ou pelo Partner Bank, o sistema deve acender a quarta parte da barra.

Para as contas que foram baixadas manualmente e nunca foram registradas, o sistema deve exibir a barra sem nenhuma parte acesa. Se a conta já foi registrada, a barra deve ficar com a primeira parte acesa.

Para as contas que foram excluídas e nunca foram registradas, o sistema também deve exibir a barra sem nenhuma parte acesa. Se a conta já foi registrada, a barra deve ficar com a primeira parte acesa.

Para as contas que foram editadas e nunca foram registradas, o sistema também deve exibir a barra sem nenhuma parte acesa. Se a conta já foi registrada, a barra deve ficar com a primeira parte acesa.

Para as contas que foram criadas no Contas a receber avulso, o sistema também deve exibir a barra sem nenhuma parte acesa.

Para as contas que foram excluídas depois da cobrança ser registrada, o sistema deve exibir a primeira parte da barra acesa, pois terá que gerar nova remessa.
 */
export const SITUACOES_CONTA_RECEBER = {
  NAO_TRATADA_BANCO: { progress: 0, hint: 'Cobrança não tratada pelo banco' },
  NAO_GERADA: { progress: 25, hint: 'Cobrança pendente de registro' },
  PENDENTE: { progress: 25, hint: 'Cobrança pendente de registro' },
  GERADA: { progress: 50, hint: 'Cobrança enviada para registro' },
  REJEITADA: { progress: 75, hint: 'Cobrança rejeitada' },
  REENVIADA: { progress: 50, hint: 'Cobrança enviada para registro' },
  ACEITA: { progress: 75, hint: 'Cobrança registrada' },
  PAGA: { progress: 100, hint: 'Cobrança paga' },
};

const NossoNumero = ({
  id,
  value,
  situacao,
  type = 'CONTA_RECEBER',
  hasError = false,
  showIconError = false,
  onClickError = () => {},
  tooltipError = '',
  reenviar = false,
  onClickReenviar = () => {},
  tooltipReenviar = '',
  reenviarDisabled = false,
  tooltipReenviarDisabled = '',
  className
}) => {
  const styles = nossoNumeroStyles();

  const formatNossoNumero = (nossoNumero) => {
    if (nossoNumero !== null && nossoNumero !== undefined) {
      return `${nossoNumero}`.padStart(9, '0');
    }
    return ``;
  };

  const mapSituacao = (_situacaoRemessa) => {
    if (type === 'CONTA_RECEBER') {
      return SITUACOES_CONTA_RECEBER[_situacaoRemessa] ? SITUACOES_CONTA_RECEBER[_situacaoRemessa].progress : 0;
    }

    return 0;
  };

  const mapSituacaoHint = (_situacaoRemessa) => {
    if (type === 'CONTA_RECEBER') {
      return SITUACOES_CONTA_RECEBER[_situacaoRemessa] ? SITUACOES_CONTA_RECEBER[_situacaoRemessa].hint : '';
    }

    return '';
  };

  const handleClickReenviar = (e) => {
    e.preventDefault();
    e.stopPropagation();

    onClickReenviar(id);
  };

  const handleClickError = (e) => {
    e.preventDefault();
    e.stopPropagation();

    onClickError(id);
  };

  return (
    <div className={styles.container}>
      <div
        className={clsx(styles.progress, hasError ? styles.error : '')}
        style={{ display: 'flex', flexDirection: 'column' }}
      >
        <div style={{ paddingTop: value ? '0' : '20px' }}>{formatNossoNumero(value)}</div>
        <Tooltip title={mapSituacaoHint(situacao)} placement="bottom" className={className}>
          <progress max="100" value={mapSituacao(situacao)} />
        </Tooltip>
      </div>
      <div className={styles.button}>
        {showIconError && (
          <Tooltip title={tooltipError} placement="bottom">
            <IconButton onClick={handleClickError}>
              <FaInfo size={12} color="black" />
            </IconButton>
          </Tooltip>
        )}
        {!showIconError && reenviar && (
          <Tooltip title={tooltipReenviar} placement="bottom">
            <IconButton onClick={handleClickReenviar}>
              <FaSyncAlt size={12} color="#B53838" />
            </IconButton>
          </Tooltip>
        )}
        {!showIconError && !reenviar && reenviarDisabled && (
          <Tooltip title={tooltipReenviarDisabled} placement="bottom">
            <IconButton>
              <FaSyncAlt size={12} color="#9D9D9D" />
            </IconButton>
          </Tooltip>
        )}
      </div>
    </div>
  );
};

export default NossoNumero;
